import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const COOKIE_NAME = 'lang';

function getLangFromCookie(): string {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : 'en';
}

i18n.use(initReactI18next).init({
  resources: { en: { translation: {} }, ko: { translation: {} } },
  lng: getLangFromCookie(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

/** 비-React 컨텍스트에서 현재 언어를 가져올 때 사용 */
export function getCurrentLanguage(): 'en' | 'ko' {
  return (i18n.language === 'ko' ? 'ko' : 'en');
}

/** I18nContext에서 언어 변경 시 i18next도 동기화 */
export function syncLanguage(lang: 'en' | 'ko') {
  if (i18n.language !== lang) {
    i18n.changeLanguage(lang);
  }
}

export default i18n;
